import React from "react";
import { motion } from "framer-motion";

const VisionMission = () => {
  // Animation variants for reusability
  const cardVariants = (direction) => ({
    hidden: {
      opacity: 0,
      x: direction === "left" ? -100 : 100,
      filter: "blur(10px)", // Smoothness ke liye halka blur effect
    },
    visible: {
      opacity: 1,
      x: 0,
      filter: "blur(0px)",
      transition: {
        duration: 1.2,
        ease: [0.16, 1, 0.3, 1], // Custom cubic-bezier for premium smoothness
      },
    },
  });

  return (
    <>
      <section className="ax-vision-mission-sec">
        <div className="container">
          <div className="row justify-content-center">

            {/* VISION CARD */}
            <div className="col-lg-8 col-md-12 text-center mb-5">
              <motion.div
                className="ax-vm-card ax-vm-card-vision"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={cardVariants("left")}
              >
                <div className="ax-vm-header d-flex align-items-center justify-content-center gap-4 mb-3">
                  <div className="ax-vm-icon-box vision-border">
                    <img
                      src="assets/images/img5.png"
                      alt="Vision"
                      className="img-fluid"
                       loading="lazy"
                    />
                  </div>

                  <div>
                    <h2 className="ax-vm-title">
                      Our&nbsp;
                      <span className="ax-arcade-text">VISION</span>
                    </h2>
                    <div className="ax-custom-logo-sec-divider">
                      <div className="ax-custom-logo-sec-line"></div>
                      <span className="ax-custom-logo-sec-star">★</span>
                      <div className="ax-custom-logo-sec-line"></div>
                    </div>
                  </div>
                </div>

                <p className="ax-vm-desc">
                  To become the go-to platform for launching
                  high-performing e-commerce websites,
                  empowering businesses worldwide to grow
                  faster, smarter, and without barriers.
                </p>
              </motion.div>
            </div>

            {/* MISSION CARD */}
            <div className="col-lg-8 col-md-12 text-center">
              <motion.div
                className="ax-vm-card-to ax-vm-card-mission"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={cardVariants("right")}
              >
                <div className="ax-vm-header d-flex align-items-center justify-content-center gap-4 mb-3">
                  <div className="ax-vm-icon-box">
                    <img
                      src="assets/images/img4.png"
                      alt="Mission"
                      className="img-fluid"
                       loading="lazy"
                    />
                  </div>

                  <div>
                    <h2 className="ax-vm-title">
                      Our&nbsp;
                      <span className="ax-arcade-text">MISSION</span>
                    </h2>
                    <div className="ax-custom-logo-sec-divider">
                      <div className="ax-custom-logo-sec-line"></div>
                      <span className="ax-custom-logo-sec-star">★</span>
                      <div className="ax-custom-logo-sec-line"></div>
                    </div>
                  </div>
                </div>

                <p className="ax-vm-desc">
                  To deliver fast, scalable, and
                  conversion-focused e-commerce solutions
                  that help brands launch in days, reduce
                  costs, and achieve real business growth.
                </p>
              </motion.div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default VisionMission;